<ng-container
  *ngIf="{
    selectedFilterConfig: selectedConfig$ | async,
    filterConfigs: configs$ | async,
    filters: filters$ | async,
    selectedItems: selectedItems$ | async
  } as state"
>
  <div
    class="mosaic-gallery-keybindings-host"
    tsEditorKeybindings
    (ctrlMetaPressed)="setMultiselectionEnabled($event)"
    (shiftPressed)="setDragSelectionEnabled($event)"
    (mousedown)="onGalleryMouseDown($event)"
  >
    <div class="flex-row flex-wrap align-items-center mosaic-gallery-toolbar">
      <div class="flex-row justify-content-start mosaic-gallery-toolbar__saved">
        <button
          mat-menu-item
          type="button"
          [matTooltip]="'button.quick_filters' | translate"
          [matMenuTriggerFor]="quickFiltersMenu"
          [matTooltipShowDelay]="500"
        >
          <mat-icon>filter_list</mat-icon>
        </button>
      </div>

      <div class="mosaic-gallery-toolbar__search">
        <ts-universal-search-bar
          class="justify-content-start"
          [fields]="searchFields"
          (optionSelected)="upsertSearchFilter($event)"
        ></ts-universal-search-bar>
      </div>

      <div class="flex-row justify-content-end mosaic-gallery-toolbar__actions">
        <button
          mat-menu-item
          type="button"
          [matTooltip]="'button.revert_selected_changes' | translate"
          [disabled]="state.selectedItems.size === 0 || !editingEnabled || syncing"
          (click)="revertSelectedRoiChanges()"
          [matTooltipShowDelay]="500"
        >
          <i class="ri-arrow-go-back-line"></i>
        </button>

        <button
          mat-menu-item
          type="button"
          [matTooltip]="'button.remove_all_labels' | translate"
          [disabled]="state.selectedItems.size === 0 || !editingEnabled || syncing"
          (click)="removeAllLabelsOnSelectedItems()"
          [matTooltipShowDelay]="500"
        >
          <mat-icon>label_off</mat-icon>
        </button>

        <button
          mat-menu-item
          type="button"
          [matTooltip]="'button.remove_panel' | translate"
          [disabled]="removePanelDisabled"
          (click)="panelCloseRequested.emit()"
          [matTooltipShowDelay]="500"
        >
          <i class="ri-close-line"></i>
        </button>
      </div>
    </div>

    <mat-menu #quickFiltersMenu="matMenu" class="widget">
      <div class="saved-configs-section">
        <div class="section-header">
          <span>{{ 'filter.saved_configurations' | translate }}</span>
        </div>

        <mat-divider></mat-divider>

        <ng-container *ngIf="state.filterConfigs">
          <button
            mat-menu-item
            *ngFor="let config of state.filterConfigs"
            (click)="applyFilterConfig(config.id, config.filters)"
          >
            <button
              mat-icon-button
              type="button"
              (click)="deleteFilterConfig(config.id)"
              [matTooltip]="'core.delete' | translate"
            >
              <mat-icon>delete</mat-icon>
            </button>
            <span>{{ config.name }}</span>
          </button>

          <div *ngIf="state.filterConfigs.length === 0" class="no-configs">
            <span>{{ 'filter.no_saved_configurations' | translate }}</span>
          </div>
        </ng-container>
      </div>
    </mat-menu>

    <ts-active-filters
      *ngIf="state.filters.length > 0"
      [filterConfigName]="state.selectedFilterConfig?.name"
      [filters]="state.filters"
      [delegate]="this"
    ></ts-active-filters>

    <div class="viewport">
      <ts-grid-view
        [attr.id]="panelId"
        [draggingDisabled]="draggingDisabled$ | async"
        [dragSelectionEnabled]="dragSelectionEnabled$ | async"
        [dragSelectionDelegate]="this"
        [paddingNodes]="paddingNodes"
        [rowNumeralTemplate]="rowNumber"
        [rowNumeralWidth]="rowNumeralWidth"
        [headerTemplate]="headerRow"
        [cellTemplate]="mosaicCell"
        [loading]="loading"
        [cellSize]="getCellSize()"
        [cellGap]="cellGap"
        [cellsPerRow]="getCellsPerRow()"
        [scrollThreshold]="scrollThreshold"
        [connectedDropLists]="connectedDropLists"
        [dataSource]="this"
        [delegate]="this"
        [scrollDelegate]="this"
        [arrowNavigationEnabled]="focused"
        (connectedDropListChanged)="connectedDropListChanged.emit($event)"
      >
        <div class="loader" slot="loader">
          <mat-progress-bar mode="query"></mat-progress-bar>
        </div>
      </ts-grid-view>

      <ng-template #headerRow let-header>
        <ng-container *ngIf="header; else emptyHeader">
          <ts-mosaic-section-header [data]="header"></ts-mosaic-section-header>
        </ng-container>

        <ng-template #emptyHeader> <div></div> </ng-template>
      </ng-template>

      <ng-template #mosaicCell let-cell>
        <ts-mosaic-cell *ngIf="cell" [data]="cell"></ts-mosaic-cell>
      </ng-template>

      <ng-template #rowNumber let-rowData>
        <ts-mosaic-row-number *ngIf="rowData" [data]="rowData"></ts-mosaic-row-number>
      </ng-template>

      <ng-template #contextMenuTemplate>
        <ng-container *ngIf="contextMenu$ | async as contextMenu">
          <ts-label-context-menu
            [categories]="contextMenu.categories"
            [options]="contextMenu.labels"
            [checkedOptions]="contextMenu.checkedOptions"
            [doubleCheckedOptions]="contextMenu.doubleCheckedOptions"
            (optionSelected)="menuOptionSelected($event)"
            (optionDeselected)="menuOptionDeselected($event)"
            (optionHovered)="setHoverLabel($event)"
            (optionUnhovered)="setHoverLabel('')"
            class="widget"
          ></ts-label-context-menu>
        </ng-container>
      </ng-template>
    </div>
  </div>
</ng-container>
